import type { ReactElement } from "react";
import { SearchInput } from "../../ui/SearchInput/SearchInput";
import { Chip } from "../../ui/Chip/Chip";
import { useBreakpoint } from "../../lib/useBreakpoint";
import { FILTERS } from "./errors";
import { useErrorsStore, useRankedProblems } from "./store";
import styles from "./ErrorFilters.module.css";

export function ErrorFilters(): ReactElement {
  const { isMobile } = useBreakpoint();
  const query = useErrorsStore((state) => state.query);
  const filter = useErrorsStore((state) => state.filter);
  const setQuery = useErrorsStore((state) => state.setQuery);
  const setFilter = useErrorsStore((state) => state.setFilter);
  const total = useErrorsStore((state) => state.index?.length ?? 0);
  const shown = useRankedProblems().length;

  return (
    <div className={styles.filters}>
      <SearchInput
        value={query}
        onChange={setQuery}
        prompt=">"
        placeholder="Search by code, title or status"
        count={`${shown}/${total}`}
      />
      <div className={styles.chips}>
        {FILTERS.map((option) => (
          <Chip
            key={option}
            size={isMobile ? "sm" : "md"}
            selected={filter === option}
            onClick={() => setFilter(option)}
          >
            {option === "All" ? `All ${total}` : option}
          </Chip>
        ))}
      </div>
    </div>
  );
}
